import React,{useLayoutEffect} from "react";
import Footer from "../components/ui/Footer";
import { Link } from "react-router-dom";
import NavbarHome from "../components/ui/NavbarHome";
import "../components/styles/common.css"
const TermsAndCondition = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div className="h-full font-nunito">
      <NavbarHome />
      <div className="flex justify-center mt-24 flex-col px-8 lg:px-48 gap-3 text-lg py-8">
        <h1 className="text-3xl font-extrabold text-center mb-8">
          Terms And Conditions
        </h1>
        <p className="w-full">
          Welcome to ScopeX website. The terms and conditions described below
          govern your access to, use of, and browsing of this website and the
          information it contains. Please take your time reading this
          information. You agree to abide by and be bound by these Terms &
          Conditions if you use this website or any of the services provided
          here.{" "}
        </p>
        <h1 className="text-2xl font-bold mt-3">Participation</h1>
        <p className="w-full">
          Any individual accessing or using the website is deemed to have read
          the terms and conditions and is absolutely and completely accepting
          them. This agreement between the user and ScopeX is enforceable and is
          governed by these terms of use and the other policies. Please
          carefully read the terms and conditions, and if you disagree with
          them, please terminate your account. In order to access certain
          services, you will be required to open a User account with ScopeX by
          providing information about yourself (such as identification and
          contact details) as part of the registration process for the services,
          or as part of your continued use of the services. You agree that any
          registration data you give to ScopeX will always be accurate, correct,
          complete and up to date. If you provide any information that is
          untrue, inaccurate, incomplete, or not current or if we have
          reasonable grounds to suspect that such information is in violation of
          applicable law or not in accordance with the terms of use (whether
          wholly or in part), we reserve the right to reject your registration
          and/ or indefinitely suspend or terminate your user account and refuse
          to provide you access to the website.
        </p>
        <h1 className="text-2xl font-bold mt-3">Data protection</h1>
        <p className="w-full">
          You can make any changes or corrections to your registration data in
          your user account by going to the "User Account" section of the
          website. At any moment, you have the option of deleting your user
          information or even your entire user account. Even though it can take
          some time, ScopeX will process the deletion. If you neglect to keep
          your login ID, password, or any other account-related credentials
          secure, we won't be responsible for any loss or damage. You must take
          all necessary precautions to keep the password private and safe. If
          you have any reason to believe that someone else knows your password
          or if it is being used or is likely to be used in an unauthorised
          manner, please contact us immediately by using the <Link to="/Contact">
            <span className="underline" data-test="contact-text">contact us</span>
          </Link>
          {" "}section of the website. You agree that ScopeX shall act as the sole
          arbitrator in any dispute between two or more parties over ownership
          of any specific account with ScopeX, and that the decision of ScopeX
          in this matter will be final and binding for everyone. <br />
          You understand and undertake that you shall be solely responsible for
          your registration data and user content and undertake to host, display
          or share any information that: <br />
          <ul className="list-disc list-inside">
            <li>
              Belongs to another person and to which you do not have any right
              to;
            </li>
            <li>
              Is harmful, harassing, relating to or encouraging money
              laundering, or otherwise unlawful in any manner whatsoever;{" "}
            </li>
            <li>Impersonates another person;</li>
            <li>
              Infringes any patent, trademark, or other proprietary rights of
              any person anywhere in the world;
            </li>
            <li>Is illegal in any other way.</li>
          </ul>
          <span className="font-bold mt-3">
            You agree and understand that ScopeX has the right to remove and/or
            delete any such information and the account itself.
          </span>{" "}
          If you come across any such information mentioned above, you are
          requested to immediately contact us.
        </p>
        <h1 className="text-2xl font-bold mt-3">
          Representations and warranties of user{" "}
        </h1>
        <p className="w-full">
          The user hereby represents and warrants: <br />
          <ul className="list-disc list-inside">
            <li>
              That user is at least 18 years old with a conscious mind fit and
              proper to enter into this agreement;
            </li>
            <li>
              That the user will hold and safeguard ScopeX from any liabilities
              arising in connection with any incidental or intentional
              discrepancy that is found to be present in the documents submitted
              by such user for the purpose of know your client (KYC)
              verification.;
            </li>
            <li>
              The user shall timely cooperate in allowing ScopeX to conduct
              transactions.
            </li>
          </ul>
        </p>
        <h1 className="text-2xl font-bold mt-3">Prohibited usage </h1>
        <p className="w-full">
          Except if agreed in a separate agreement with ScopeX, you agree not to
          access (or attempt to access) any of the services using a method other
          than the interface provided by ScopeX. You hereby ensure not to use
          any automated method to access (or attempt to access) any of the
          services. <br /> <br /> You agree that you will not engage in any
          activity that interferes with or disrupts the services (or the servers
          and networks which are connected to the services) on this website.
          Unless you have been specifically permitted to do so in a separate
          agreement with ScopeX, you agree that you will not reproduce,
          duplicate, copy, sell, trade or resell the services for any purpose.{" "}
          <br /> <br />
          Any content created by the user or their registration information may
          be shared by ScopeX with governmental and regulatory organisations
          that are duly permitted to conduct cyber security, protection, and
          investigative operations. Such information may be sent for the purpose
          of confirming identity, as well as for the prevention, discovery,
          investigation, and prosecution of cyber security incidents. The user
          represents and warrants that it will be financially responsible for
          usage and access to the website. The user shall also be responsible
          for use of their account by others. The terms of use shall be void
          where prohibited by applicable laws, and the right to access the
          website shall automatically stand revoked in such cases.
        </p>
        <h1 className="text-2xl font-bold mt-3">Account</h1>
        <p>
          You might be able to register on the website. If the website enables
          you to create several accounts, including sub-accounts, all of these
          accounts are referred to as "your" account. You may not create more
          than the maximum number of accounts that the website permits, nor may
          you create any anonymous accounts that do not accurately reflect your
          true identity. You will ensure that no user that is authorized by you
          to access your account in accordance with this agreement will share
          any login credentials for your account with any other person unless we
          expressly permit such sharing in writing. Depending on the
          functionality that we make available to you through the account, you
          may be able to use the account to access, use and/or manage various
          aspects of the services, your data (in whole or in part), and/or other
          functionality. You are responsible at all times for all activities and
          use of your account, and you must safeguard all login credentials and
          passwords that access your account. You must notify us immediately if
          you believe that your account was compromised, or if any user of your
          account is engaging in any wrongful conduct, including any breach of
          this agreement or any violation of any applicable law or regulation.{" "}
          <h3 className="text-xl py-3 font-bold">Authorization</h3>
          By accepting these terms of use, you authorize us to transfer and
          settle funds on your behalf. Your authorization permits us to generate
          an electronic funds transfer between the sender and the receiver.
        </p>
        <h1 className="text-2xl font-bold mt-3">Third-party links</h1>
        <p>
          Links to the websites of our partner networks, advertisers, and
          affiliates may occasionally be found in our services. Please be aware
          that we deny all responsibility for these websites' privacy policies,
          so before providing any personal information to them via a link,
        </p>
        <h1 className="text-2xl font-bold mt-3">Liabilities and disclaimer </h1>
        <p>
          If you use the services or violate this agreement, you agree to
          defend, indemnify, and hold us and our affiliated entities harmless
          from all claims, liabilities, and costs, including reasonable lawyers'
          fees and costs (collectively referred to as "Claims"). We reserve the
          right to take on the complete responsibility for the defence and
          management of any Claims, at our sole discretion and expense. You
          consent to reasonably assist us, at our request, in defending any
          claims. "Our Affiliated Entities" refers to our direct and indirect
          business partners, clients, licensees, users, vendors, investors, and
          shareholders (past, present, or future), as well as our predecessors,
          agents, attorneys, and advisers.
        </p>
        <h1 className="text-2xl font-bold mt-3">Termination and suspension</h1>
        <p>
          To protect the integrity of our services or systems, to adhere to our
          policies or applicable laws and regulations, if you fail to comply
          with this agreement, if you no longer agree to receive electronic
          communications, or for any other reason, we may, in our sole
          discretion and without notice, restrict, deny, terminate this
          agreement or suspend the services and/or your account, effective
          immediately, in whole or in part. Upon termination of this agreement,
          or suspension or termination of your account, you must immediately
          stop using the services and any outstanding payments will become due
          immediately.
        </p>
        <h1 className="text-2xl font-bold mt-3">Changes to this agreement</h1>
        <p className="mb-10">
          To stay current with changing legal requirements, standard operating
          procedures, and changes in how we process personal information, we
          reserve the right to modify this agreement at any time without prior
          notice by releasing a new version on our website. To stay up to date,
          check back periodically.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndCondition;
